import React from 'react'
import Constants from '../services/constants/Constants'

class Base extends React.Component {
  _bind (...methods) {
    methods.forEach((method) => this[method] = this[method].bind(this))
  }

  _getItemIDFromDrop (event, withID) {
    let dataTransfer = event.dataTransfer.getData('text/html')
    let dataID = 0
    if (dataTransfer.length) {
      let regex
      if (withID === 'imageid') {
        regex = /data-imageid="([^"]*)"/
        dataID = dataTransfer.match(regex)
        dataID = parseInt(dataID[1], 0)
      } else if (withID === 'section') {
        dataID = {
          iconCategory: dataTransfer.match(/data-category="([^"]*)"/)[1],
          iconName: dataTransfer.match(/data-icon="([^"]*)"/)[1],
        }
      } else if (withID === 'filename') {
        regex = /data-filename="([^"]*)"/
        if (dataTransfer.match(regex)[1]) {
          dataID = dataTransfer.match(regex)[1]
        } else {
          dataID = null
        }
      } else if (withID === 'mediatype') {
        regex = /data-mediatype="([^"]*)"/
        if (dataTransfer.match(regex)[1]) {
          dataID = dataTransfer.match(regex)[1]
        } else {
          dataID = null
        }
      }
    } else {
      dataTransfer = event.dataTransfer.getData('text')

      if (withID === 'imageid') {
        dataID = parseInt(dataTransfer.replace(Constants.UrlsConstants.urlServer+
          Constants.UrlsConstants.mediaMiniature, '')
          .replace(Constants.UrlsConstants.authTokenParam, ''), 0)
      } else if (withID === 'section') {
        dataID = {
          iconCategory: dataTransfer.split('/')[6],
          iconName: dataTransfer.split('/')[7],
        }
      } else if (withID === 'filename') {
        dataID = parseInt(dataTransfer.replace(Constants.UrlsConstants.urlServer+
          Constants.UrlsConstants.mediaMiniature, '')
          .replace(Constants.UrlsConstants.authTokenParam, ''), 0)
      }
    }
    return dataID
  }

}

export default Base
